import styled from "styled-components"

import {H4} from "@irati/ui/src/Headings"
import padding from "@irati/ui/src/global/padding"

export const StyledH4 = styled(H4)`
  margin-top: ${padding.base};
`

export const TermsAndConditionsWrapper = styled.div`
  display: inline-flex;
  ${({theme}) => `margin: ${theme.spacing.two} 0 0 -${theme.spacing.two};`}
`

export const UnderlineLink = styled.a`
  text-decoration: underline;
`
